import template from './groupsButton.html';

export default {
  name: 'groupsButton',
  template,
  controller: GroupsButtonController,
  bindings: {
    expanded: '<?'
  }
};

/* @ngInject */
function GroupsButtonController($scope, GroupsButtonService) {
  const vm = this;

  let cache;

  vm.editState = false;

  vm.$onInit = onInit;
  vm.$postLink = postLink;
  vm.flipState = flipState;

  function onInit() {
    cache = GroupsButtonService.cache;
  }

  function postLink() {
    $scope.$watch(() => cache.totalGroupsSelected, (__, total) => {
      vm.totalGroupsSelected = cache.totalGroupsSelected;
      total === 0 && setEditState(Boolean(vm.expanded));
    });
  }

  function flipState() {
    setEditState(!cache.editState);
  }
  function setEditState(state) {
    cache.editState = state;
    vm.editState = state;
  }
}
